import {ordersServicesPath} from "../../Constants";
import axios from "axios";

const optimizationServiceRestUrl = ordersServicesPath + '/organizations/verso/details/optimization'

export default class VersoDetailService {

    static async downloadDrilling(id) {
        return axios.get(optimizationServiceRestUrl + '/drilling/download?optimizationId=' + id, {
            responseType: 'blob'
        })
    }

    static async downloadCutting(id) {
        return axios.get(optimizationServiceRestUrl + '/cutting/download?optimizationId=' + id, {
            responseType: 'blob'
        })
    }
}